import { render, staticRenderFns } from "./TeachingNewForm.vue?vue&type=template&id=565dd208"
import script from "./TeachingNewForm.vue?vue&type=script&lang=js"
export * from "./TeachingNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports